export default __webpack_public_path__ + "static/media/1-4-3.b42eb67b.webp";